var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthereum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#627EEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5L15.85 5.51V20.31L16 20.46L22.87 16.4L16 5Z",
    fill: "white",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5L9.13 16.4L16 20.46V13.28V5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.77L15.91 21.88V27.15L16 27.41L22.88 17.72L16 21.77Z",
    fill: "white",
    fillOpacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 27.41V21.77L9.13 17.72L16 27.41Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20.46L22.87 16.4L16 13.28V20.46Z",
    fill: "white",
    fillOpacity: 0.45
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13 16.4L16 20.46V13.28L9.13 16.4Z",
    fill: "white",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.fb5feb3c8fee793a6ceac0a5f61f2983.svg";
export { ForwardRef as ReactComponent };